import { render, staticRenderFns } from "./ListNavigations.vue?vue&type=template&id=84f931d8&scoped=true&"
import script from "./ListNavigations.vue?vue&type=script&lang=js&"
export * from "./ListNavigations.vue?vue&type=script&lang=js&"
import style0 from "./ListNavigations.vue?vue&type=style&index=0&id=84f931d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f931d8",
  null
  
)

export default component.exports